export const mensagemCampoObrigatorio = (campo) => {
  return `Informe ${campo}`;
};

export const mensagemMinimoXCaracteres = (quantidade) => {
  return `É necessário informar pelo menos ${quantidade} caracteres no campo.`;
};

export const mensagemPeriodoMaximoDeMeses = (quantidade) => {
  return `Informe um período de no máximo ${quantidade} meses.`
}

export const mensagemMinimo3Caracteres = mensagemMinimoXCaracteres(3);